import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import {
  EpGridComponent, IEpGridModel, EpLocalStorageService, EpGridEvent,
  IEpGridSelectionOptions, IEpGridState, IEPGridDataResult,
  EpEventService, EpButtonStyle, IEpComponentEventArg, IEpGridSelectableSettings
} from '@epicor/kinetic';
import { Observable } from 'rxjs';
import {
  BistrackConfig, CustomerStatusType, CustomerStatusIcon,
  CustomerStatusColor, LocalStorageSaveTypes,
  CustomEvents, PageNames, DocumentTypes, TabTitle, SearchPageNames
} from 'ep-bt-controls';
import { EpbtFaCompetitorService } from '../../services/epbt-fa-competitor.service';
import {
  FieldAgentClient, CustomerSearchParameters,
  CustomerSearchParametersCustomerStatus, CustomerSearchParametersDeliverytype,
  SortParametersDirection, PagingParameters, SortParameters, CustomerCreditControlStatusType
} from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { EpbtFaNotepadService } from '../../services/epbt-fa-notepad.service';
import { Location } from '@angular/common';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaDocumentService } from '../../services/epbt-fa-document.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';


declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-customer-grid',
  templateUrl: './epbt-fa-customer-grid.component.html',
  styleUrls: ['./epbt-fa-customer-grid.component.scss']
})
export class EpbtFaCustomerGridComponent implements OnInit {
  dockType = 'horizontal';
  EpButtonStyle = EpButtonStyle;

  customers: any;
  private _searchString: string;

  @Input() navigation: boolean;
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
  }

  get searchString(): string { return this._searchString; }
  @Output() loadingChange = new EventEmitter<boolean>();

  @ViewChild('emailTemplate', { static: false }) emailTemplate: TemplateRef<any>;
  @ViewChild('statusTemplate', { static: false }) statusTemplate: TemplateRef<any>;
  @ViewChild('mobileTemplate', { static: false }) mobileTemplate: TemplateRef<any>;
  @ViewChild('telTemplate', { static: false }) telTemplate: TemplateRef<any>;
  @ViewChild(EpGridComponent, { static: false }) grid: EpGridComponent;

  // Events
  @Output() epOnCellClick = new EventEmitter<any>();

  tabTitle = TabTitle;
  gridModel: IEpGridModel;
  pageSize = 50;

  customersCollection: any = [];
  totalPages = 1;
  showGrid = true;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;
  // @Input() isPopup: boolean = false;

  constructor(private client: FieldAgentClient, private router: Router, private config: BistrackConfig,
    private localStorageService: EpLocalStorageService,
    private fieldAgentService: EpbtFieldAgentService, public epEvent: EpEventService,
    private epbtFaCompetitorService: EpbtFaCompetitorService,
    private customerService: EpbtFaCustomerService, private location: Location,
    public quickOrderService: EpbtFaQuickOrderService,
    private faDocumentService: EpbtFaDocumentService,
    private notepadService: EpbtFaNotepadService,
    private sortService: EpbtFaSortService,
    private filterService: EpbtFaFilterService) {
    this.epEvent.onEvents([CustomEvents.CustomerSearch]).subscribe(event => {
      this._searchString = event.data ? event.data : '';
      this.sortService.customerSearchValue = this._searchString;
      this.customerService.getCustomer(this._searchString, this.epbtFaCompetitorService.isCompetitor ? 1 : 0, (selectedCustomer: any) => {
        if (selectedCustomer) {
          this.epOnCellClick.emit(selectedCustomer);
        } else {
          this.updateGridData();
        }
      });

      // if (this.customerService.fromPage !== PageNames.CustomerSearch) {
      //   if (event.data == '' && sortService.isFromSorting) {
      //     this.customerService.isCustomersSearchMessage = true;
      //     this.updateGridData();
      //   }
      //   else if (event.data == undefined || event.data == '') {
      //     this.customerService.isCustomersSearchMessage = true;
      //     this.updateGridData();
      //   }

      //   else {
      //     this.customerService.isCustomersSearchMessage = false;
      //     this.updateGridData();
      //   }
      // }
      // else {
      // this.sortService.customerSearchValue = this._searchString;
      // this.updateGridData();
      // }
    });
  }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
      // this.gridModel = this.getGridModel([]);
    });
  }
  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }

  getGridModel(customersList: any): IEpGridModel {
    // alert(this._searchString);
    const selectSettings: IEpGridSelectableSettings = {
      checkboxOnly: false,
      mode: 'single',
    };
    const selectionOptions: IEpGridSelectionOptions = {
      showCheckBox: false,
      showSelectAll: false,
      selectByField: 'customerId',
      selectedKeys: [],
    };

    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      selectable: selectSettings,
      data: customersList,
      columns: [
        { field: 'customerId', title: 'CUSTOMER ID', width: 0, hidden: true },
        { field: 'name', title: 'CUSTOMER NAME', width: 120, hidden: false, class: 'ep-cutomerName' },
        { field: 'customerCode', title: 'CUST.  CODE', width: 80, hidden: false },
        { field: 'telephone1', title: 'TELEPHONE', width: 80, hidden: false, cellTemplate: this.telTemplate },
        { field: 'mobile', title: 'MOBILE', width: 80, hidden: false, cellTemplate: this.mobileTemplate },
        { field: 'email', title: 'EMAIL', width: 100, hidden: false, cellTemplate: this.emailTemplate },
        { title: 'STATUS', width: 100, hidden: false, cellTemplate: this.statusTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          // this.naviagteTo(eventArg.event.dataItem);
          this.epOnCellClick.emit(eventArg.event.dataItem);
        }
      },

      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, customersList, false);
        return observerResult;
      }
    };

    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, customersList, isMobile: boolean): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.customersCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {
        if (!isMobile) {
          epGrid.model.loadingIndicator = true;
        }
        const searchCustomerParams = new CustomerSearchParameters();
        if (this.epbtFaCompetitorService.isCompetitor && this.customerService.fromPage != PageNames.QuickOrder &&
          this.customerService.fromPage != PageNames.OpportunityDashboard && this.customerService.fromPage != PageNames.NotepadDashboard &&
          this.customerService.fromPage != PageNames.CalendarDashboard && this.customerService.fromPage != PageNames.ContactsSearch) {
          searchCustomerParams.competitor = 1;
          searchCustomerParams.customerStatus = CustomerSearchParametersCustomerStatus.All;
        } else {
          searchCustomerParams.competitor = 0;
          searchCustomerParams.customerStatus = CustomerSearchParametersCustomerStatus.CustomerOrProspect;
        }
        searchCustomerParams.customersLimitSearchToHomeBranch = true;
        const page = new PagingParameters();
        page.index = state.skip;
        page.count = this.pageSize;
        searchCustomerParams.paging = page;
        const sort = new SortParameters();
        sort.sortColumn = this.sortService.customerSortValue;
        sort.direction = this.sortService.customerDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        searchCustomerParams.sorting = sort;
        searchCustomerParams.searchText = this._searchString;
        this.navigation = false;
        searchCustomerParams.deliverytype = CustomerSearchParametersDeliverytype.All;

        searchCustomerParams.bisTrackUserID = this.config.getLoggedinUser(); // need to check
        this.client.findCustomers(searchCustomerParams).subscribe(res => {
          customersList = res.lines;
          if (customersList != null && customersList != undefined && customersList.length > 0) {
            this.totalPages = res.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }

            this.customerService.getcustomerStatus(customersList);
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (customersList.length < state.take) {
              this.lastRecords = customersList;
            } else {
              this.customersCollection = [...this.customersCollection, ...customersList];
            }
            if (!isMobile) {
              this.mobileData = this.customersCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.customersCollection.length;
            const result: IEPGridDataResult = {
              data: customersList,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  updateGridData() {
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    this.customersCollection.length = 0;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
  }

  getMobileData() {

    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        let customersList;
        this.getGridModelData(epGrid, state, customersList, true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }


  getHeight(): number {
    const height = $(window).outerHeight() - 192;
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }

    // if (this.dockType != 'vertical') {
    //   //horizontal
    //   return height - 10;
    // } else {
    //   return height / 2 - 80
    // }
    return height;
  }

  onCardClick(model) {
    this.epOnCellClick.emit(model);
  }

}
